/** @flow */

import type { State } from "@store/reducers";
import type { EffectiveUserPermissions } from "@modules/service/reducer/user-permissions/types";

export const isLoading = (state: State): boolean =>
  !!state.service.userPermissions.requestsInProgress;

export const getEffectiveUserPermissions = (state: State): EffectiveUserPermissions =>
  state.service.userPermissions.effectiveUserPermissions;

export const getEffectiveUserPermissionsSchema = (state: State): ?Object =>
  state.service.userPermissions.schema;

export const getManagementUsersSchema = (state: State) => {
  const schema = getEffectiveUserPermissionsSchema(state) || {};

  return {
    ...schema,
    properties: schema.properties
      ? {
          notificationAdmin: schema.properties.notificationAdmin,
          excludeAbsencesFromAlerts: schema.properties.excludeAbsencesFromAlerts,
          allowManagerEditEmployeesShiftPattern:
            schema.properties.allowManagerEditEmployeesShiftPattern,
        }
      : {},
  };
};

export const getEmployeeUsersSchema = (state: State) => {
  const schema = getEffectiveUserPermissionsSchema(state) || {};

  return {
    ...schema,
    properties: schema.properties
      ? {
          employeeAccounts: schema.properties.employeeAccounts,
          benchmarkingStatistics: schema.properties.benchmarkingStatistics,
          absenceMonitoringDetails: schema.properties.absenceMonitoringDetails,
          viewRtwForms: schema.properties.viewRtwForms,
        }
      : {},
  };
};

export const getAbsenceUpdatePermissionsSchema = (state: State) => {
  const schema = getEffectiveUserPermissionsSchema(state) || {};

  return {
    ...schema,
    properties: schema.properties
      ? {
          reportAbsences: schema.properties.reportAbsences,
          updateAbsences: schema.properties.updateAbsences,
          permittedExtension: schema.properties.permittedExtension,
          closeAbsences: schema.properties.closeAbsences,
        }
      : {},
  };
};

export const showEmployeeUsersModal = (state: State): boolean =>
  state.service.userPermissions.modals.showEmployeeUsersModal;
